import React from 'react';
import { Row, Col, Card, Placeholder } from 'react-bootstrap';
import { QRCode } from 'react-qr-code';
import PropTypes from 'prop-types';
import { useToast } from 'context/providers/ToastProvider';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFingerprint } from '@fortawesome/free-solid-svg-icons';

const SellosDigitales = ({ datosSellos, value }) => {
    const { showSuccessToast, showErrorToast } = useToast();

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            showSuccessToast('Copiado');
        } catch (err) {
            console.error('Failed to copy: ', err);
            showErrorToast('Error al copiar');
        }
    };


    const isReady = datosSellos && Object.keys(datosSellos).length > 0;

    return (
        <>
            <Row className="mb-4">
                <Col md={12}>
                    <Card className="border-2 shadow-sm">
                        <Card.Body className="p-3">
                            <Card.Title className="fw-bold mb-3">SELLO DIGITAL DEL CFDI</Card.Title>
                            <div className="mb-3">
                                <p className="text-break mb-4" style={{ fontSize: '0.75rem' }}>
                                    {isReady ? datosSellos.SelloCFD : <Placeholder animation="wave"><Placeholder xs={12} /><Placeholder xs={12} /></Placeholder>}
                                </p>
                            </div>
                            <Row className="mb-3 border-top pt-3">
                                <Col md={4}>
                                    <h6 className="fw-bold mb-2"><FontAwesomeIcon icon={faFingerprint} className="me-2 text-muted" />FOLIO FISCAL</h6>
                                    {isReady ? (
                                        <Link style={{ cursor: 'pointer', fontSize: '0.75rem' }} onClick={() => copyToClipboard(datosSellos.UUID)} to={"#"}>{datosSellos.UUID}</Link>
                                    ) : (
                                        <Placeholder animation="wave"><Placeholder xs={8} /></Placeholder>
                                    )}
                                </Col>
                                <Col md={4}>
                                    <h6 className="fw-bold mb-2">CERTIFICADO SAT</h6>
                                    <p style={{ fontSize: '0.75rem' }}>{isReady ? datosSellos.NoCertificadoSAT : <Placeholder animation="wave"><Placeholder xs={6} /></Placeholder>}</p>
                                </Col>
                                <Col md={4}>
                                    <h6 className="fw-bold mb-2">FECHA DE TIMBRADO</h6>
                                    <p style={{ fontSize: '0.75rem' }}>{isReady ? datosSellos.FechaTimbrado : <Placeholder animation="wave"><Placeholder xs={7} /></Placeholder>}</p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="align-items-start">
                <Col xs={12} md={3} lg={2} className="text-center text-md-start mb-4 mb-md-0">
                    <div style={{ height: "auto", margin: "0 auto", maxWidth: 180, width: "100%" }}>
                        {isReady ? (
                            <QRCode 
                                value={value || ''} 
                                size={256} 
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                viewBox="0 0 256 256"
                                level="H" 
                            />
                        ) : (
                            <Placeholder animation="wave" className="w-100" style={{ height: 180 }}><Placeholder xs={12} className="h-100" /></Placeholder>
                        )}
                    </div>
                </Col>
                <Col xs={12} md={9} lg={10}>
                    <div className="mb-3">
                        <h6 className="fw-bold mb-2">SELLO DIGITAL SAT:</h6>
                        <p className="text-break mb-4" style={{ fontSize: '0.75rem' }}>
                            {isReady ? datosSellos.SelloSAT : <Placeholder animation="wave"><Placeholder xs={12} /><Placeholder xs={10} /></Placeholder>}
                        </p>
                    </div>
                    <div className="mb-3">
                        <h6 className="fw-bold mb-2">
                            CADENA ORIGINAL DEL COMPLEMENTO DE CERTIFICACIÓN DIGITAL DEL SAT:
                        </h6>
                        <p className="text-break mb-3" style={{ fontSize: '0.75rem' }}>
                            {isReady ? datosSellos.certificacionSat : <Placeholder animation="wave"><Placeholder xs={12} /><Placeholder xs={12} /><Placeholder xs={8} /></Placeholder>}
                        </p>
                    </div>
                </Col>
            </Row>
        </>
    );
};

SellosDigitales.propTypes = {
    datosSellos: PropTypes.object,
    value: PropTypes.string,
};

export default SellosDigitales;